import { getTranslateNsT } from "@/utils/getTranslateNsT";

export const timeFormatter = (value: number, type?: number) => {
  const t = getTranslateNsT("center");

  if (value !== null && value !== undefined) {
    let minutes = 0;
    let seconds = 0;
    let hours = 0;
    if (type === 1) {
      // value is million second
      value /= 1000; // million seconds should be computed to seconds
    }
    hours = Math.floor(value / 3600);
    let remainSeconds = value - hours * 3600;
    if (remainSeconds > 60 || remainSeconds === 0) {
      minutes = Math.floor(remainSeconds / 60);
      remainSeconds = value - hours * 3600 - minutes * 60;
      if (remainSeconds > 0) {
        seconds = remainSeconds;
      }
    } else {
      seconds = remainSeconds;
    }
    const hoursStr = hours > 0 ? `${hours}${t("hours")}` : "";
    const minutesStr = minutes > 0 ? `${minutes}${t("minutes")}` : "";
    const secondsStr = seconds > 0 ? `${seconds}${t("seconds")}` : "";
    return `${hoursStr}${minutesStr}${secondsStr}`;
  }
  return "0";
};
